import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';

@Component({
  selector: 'fgb-worksheet-list',
  templateUrl: './worksheet-list.component.html',
  styleUrls: ['./worksheet-list.component.scss'],
})
export class WorksheetListComponent implements OnInit {
  @Input() isList: boolean = true;
  @ViewChild('outlet', { read: ViewContainerRef }) outletRef: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef }) contentRef: TemplateRef<any>;
  isWorksheetItems: boolean = false;
  currentItem: WorksheetItem;
  worksheetId: number;
  worksheetType = WorksheetType;
  currentPage: string = this.router.url.replace('/', '');
  worksheets$ = this.worksheetQuery.getWorksheetByRoute(this.currentPage);

  constructor(private worksheetService: WorksheetService, private worksheetQuery: WorksheetQuery, private router: Router) {}

  ngOnInit() {
    if (!this.worksheetQuery.hasRoute(this.currentPage)) {
      this.worksheetService.fetchWorksheetByRoute(this.currentPage).toPromise();
    }
    this.worksheets$.subscribe((data) => {
      if (data.length > 0 && data[0].Items) {
        const activeItems = this.getActiveItems(data);
        if (activeItems.length > 0) {
          this.isWorksheetItems = false;
          this.currentItem = activeItems[0];
        } else {
          this.isWorksheetItems = true;
        }
        data.map((item) => {
          if (item.WorksheetId) {
            this.worksheetId = item.WorksheetId;
          }
        });
      }
    });
  }
  private getActiveItems(worksheets: Worksheet[]): WorksheetItem[] {
    return worksheets.flatMap((group: Worksheet) => group.Items.filter((item) => item.WorksheetType === this.worksheetType.ProviderVideo && item.Active === 1));
  }

  selectWorksheetItem(worksheetItem: WorksheetItem) {
    this.currentItem = worksheetItem;
    this.rerender();
  }

  hasWorksheetType(items: WorksheetItem[], value: number): boolean {
    const filteredItems = items.filter((item) => item.WorksheetType === value);
    if (filteredItems.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  rerender() {
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }
}
